import { NewsletterSignup } from '@/components/NewsletterSignup';
import { LabradorComponent } from '@/types/component';
import { getOcelotConfig } from 'lib/configs/ocelot';

export const LabradorNewsletterSignup: LabradorComponent = ({ type, data, meta }) => {
  if (!getOcelotConfig('features.newsletterSignup.enabled')) return null;

  return (
    <NewsletterSignup
      headline={data.headline}
      description={data.infoText}
      footer={data.integrityText}
      successModal={{
        content: data.successText,
      }}
      submitButton={{
        content: data.submitLabel,
      }}
    />
  );
};
